import PropTypes from "prop-types";
import React from "react";
import { FormField, localise } from "cxa-form-field";
import { Radio } from "cxa-components";
import { FormattedMessage, intlShape } from "react-intl";
import messages from "components/messagesDescription";

const renderRadioButtons = ({
  items,
  valueKey = "value",
  labelKey = "label",
  value,
  id,
  intl,
  error,
  meta,
  flat,
  ...rest
}) => (
  <div>
    {items.map((item, i) => (
      <Radio
        className="cxa-c-form__block-label cxa-c-form__block-label--radio"
        id={`${id}-${i}`}
        key={item[valueKey]}
        value={item[valueKey]}
        checked={item[valueKey] == value}
        {...rest}
      >
        {labelKey && localise(item[labelKey], intl)}
      </Radio>
    ))}
  </div>
);

renderRadioButtons.propTypes = {
  items: PropTypes.array,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  intl: intlShape.isRequired,
  error: PropTypes.any,
  meta: PropTypes.object,
  flat: PropTypes.any,
};

const RadioButtons = props => <FormField component={renderRadioButtons} {...props} />;

const RadioType = ({ question, selectedLanguage }) => (
  <div>
    {question.tag === "nutrition_usually_eat" && (
      <div className="cxa-grid__wrapper">
        <div className="cxa-grid__item cxa-grid__item--six">
          <figure>
            <img src="/assets/images/wellness/nutrition_fat_info_high.png" alt="" />
            <figcaption>
              <FormattedMessage {...messages.highfatDescription} />
            </figcaption>
          </figure>
        </div>
        <div className="cxa-grid__item cxa-grid__item--six">
          <figure>
            <img src="/assets/images/wellness/nutrition_fat_info_low.png" alt="" />
            <figcaption>
              <FormattedMessage {...messages.lowFatDescription} />
            </figcaption>
          </figure>
        </div>
      </div>
    )}

    {question.tag === "nutrition_breads_grains" && (
      <div>
        <h3>
          <FormattedMessage {...messages.breadgrainDescription} />
        </h3>
        <div className="cxa-grid__wrapper">
          <div className="cxa-grid__item cxa-grid__item--six">
            <figure>
              <img src="/assets/images/wellness/nutrition_grains_info_refined.png" alt="" />
              <figcaption>
                <FormattedMessage {...messages.refinedGrainDescription} />
              </figcaption>
            </figure>
          </div>
          <div className="cxa-grid__item cxa-grid__item--six">
            <figure>
              <img src="/assets/images/wellness/nutrition_grains_info_whole.png" alt="" />
              <figcaption>
                <FormattedMessage {...messages.wholeGrainDescription} />
              </figcaption>
            </figure>
          </div>
        </div>
      </div>
    )}

    <p>
      <FormattedMessage id={question.questionText} defaultMessage={question.questionText} />
    </p>
    <RadioButtons
      items={question.questionOptions}
      valueKey="questionOptionId"
      labelKey="options"
      name={`question_${question.tag}`}
    />
  </div>
);

RadioType.propTypes = {
  question: PropTypes.object,
  selectedLanguage: PropTypes.object,
};

export default RadioType;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/display-types/radio.jsx